import {
  canShowBySuppressionKey,
  suppressBySuppressionKey,
} from '../../../shared/services/localStorageSuppression';

const CALENDAR_PROMPT_KEY = 'calendarRegisterPromptSuppressedUntil';

export const DEFAULT_SUPPRESSION_DAYS = 14;

export const canShowCalendarPrompt = (now: Date = new Date()): boolean =>
  canShowBySuppressionKey(CALENDAR_PROMPT_KEY, now);

export const suppressCalendarPrompt = (
  days: number = DEFAULT_SUPPRESSION_DAYS,
  now: Date = new Date(),
): void => suppressBySuppressionKey(CALENDAR_PROMPT_KEY, days, now);
